import { styled } from '../ui/muiReexports';
export const HidableBox = styled('div', { shouldForwardProp: (prop) => prop !== 'visible' })(({ visible }) => ({
    display: visible ? 'flex' : 'none',
    flexDirection: 'column',
    flex: 1,
}));
